import styled from 'styled-components';

export const List = styled.ul`
	width: 100%;
	padding: 20px;

	display: flex;
	flex-direction: column;
	gap: 20px;
`;

export const Option = styled.div<{ color: string }>`
	width: 100%;

	display: flex;
	flex-direction: row;
	justify-content: flex-start;
	align-items: center;
	gap: 8px;

	svg {
		width: 24px;
		height: 24px;
		aspect-ratio: 1/1;

		fill: ${({ theme, color }) => theme[color]};
		stroke: ${({ theme, color }) => theme[color]};
	}
`;
